export default __webpack_public_path__ + "static/media/edidiong.fc642850.jpeg";